module.exports = __webpack_public_path__ + "static/media/comic2011c.mobile.35da797d.png";